import React, { FC, ReactNode } from "react";
import {
  ButtonLoader,
  ButtonLoaderProps,
  RoundButtonLoader,
  Spinner,
  SpinnerLoaderProps,
  ThreeDotLoader,
  ThreeDotLoaderProps,
} from "./loaders";

export type LoaderTypes = "buttonLoader" | "spinnerLoader" | "threeDotLoader";

export type CustomSpinnerLoaderProps = SpinnerLoaderProps & {
  stroke?: string;
  containerClass?: string;
  wrapperClass?: string;
};

export type LoaderOptions = {
  buttonLoader: ButtonLoaderProps;
  spinnerLoader: CustomSpinnerLoaderProps;
  threeDotLoader: ThreeDotLoaderProps;
};
type RenderOptions = {
  [loaderType in LoaderTypes]: (options?: LoaderOptions[loaderType]) => React.ReactNode;
} & {
  /**
   * @deprecated
   * No styles present, do not use
   */
  roundButtonLoader: (options?) => React.ReactNode;
};

export type LoaderProps = {
  isLoading: boolean;
  render: (renderOptions: RenderOptions) => React.ReactNode;
  displayChildren?: boolean;
  children?: ReactNode;
};

const Loader: FC<LoaderProps> = ({
  isLoading,
  render,
  children = null,
  displayChildren = false,
}) => {
  const renderSpinningLoader = (customProps: CustomSpinnerLoaderProps = {}) => {
    const { stroke = "#AEB6BF", containerClass = "", wrapperClass = "" } = customProps;
    return (
      <div className={`loader-wrapper ${wrapperClass}`}>
        <div className={`btn-loader ${containerClass}`}>{Spinner({ stroke, ...customProps })}</div>
      </div>
    );
  };

  return (
    <>
      {isLoading ? (
        <>
          {render({
            buttonLoader: (options) => <ButtonLoader {...options} />,
            spinnerLoader: renderSpinningLoader,
            roundButtonLoader: RoundButtonLoader,
            threeDotLoader: ThreeDotLoader,
          })}
          {displayChildren && children}
        </>
      ) : (
        children
      )}
    </>
  );
};

export default Loader;
